import { getRGBA } from './helpers';
import { colors as uiColors } from '@cobliteam/ui/theme';

const colors = {
  black: '#1e2535',
  white: '#ffffff',
  primary: {
    default: '#1774f0',
    hover: '#0234e1',
    disabled: '#8ab9f7',
    royal: '#001BB8',
  },
  secondary: {
    default: uiColors.gray[12],
    hover: uiColors.gray[11],
    disabled: uiColors.gray[4],
    dark: uiColors.gray[12],
  },
  error: {
    default: uiColors.danger[9],
    hover: uiColors.danger[4],
    disabled: uiColors.danger[2],
  },
  success: {
    default: uiColors.success[9],
    hover: uiColors.success[4],
    disabled: uiColors.success[2],
  },
  gray: {
    default: uiColors.gray[9],
    dark: uiColors.gray[10],
    light: uiColors.gray[4],
    lightest: uiColors.gray[2],
  },
  warning: {
    default: uiColors.warning[9],
    hover: uiColors.warning[4],
    disabled: uiColors.warning[2],
  },
  accessory: {
    _1: '#e25d6d',
    _2: '#9775fa',
    _3: '#f06595',
    _4: '#c0eb75',
    _5: '#179eee',
    /**
     * @deprecated This colors are deprecated and will be removed in the future.
     */
    _6: '#108ce9',
    /**
     * @deprecated This colors are deprecated and will be removed in the future.
     */
    _7: '#596bd1',
  },
  chart: {
    _1: '#f06595',
    _2: '#179eee',
    _3: '#9775fa',
    _4: '#c0eb75',
    _5: '#DF0D54',
    _6: '#FCAA27',
    _7: '#297EE3',
    _8: '#CF26EC',
    _9: '#311B92',
    _10: '#83DF0F',
    _11: '#295737',
    _12: '#50C3C1',
    _13: '#FD6D49',
  },
  shadows: {
    getShadow: (color: string, opacity = 0.2) => getRGBA(color, opacity),
    default: 'rgba(157, 169, 182, 0.2)',
  },
  /**
   * @deprecated This colors are deprecated and will be removed in the future.
   */
  custom: {
    primary10: 'rgba(23, 116, 240, 0.1)',
    primary05: 'rgba(23, 116, 240,  0.05)',
    lightPrimary: 'rgb(232, 244, 253)',
    lightestGray50: 'rgba(244, 247, 249, 0.5)',
    lightestGray50Alternative: '#fafcfd',
    lightGray50: 'rgba(221, 229, 237, 0.5)',
    lightGray50Alternative: '#fafbfc',
    lightGray50Alternative2: '#e9eef3',
    lightGray50Alternative3: '#f2f8ff',
    gray50: 'rgba(157, 169, 182, 0.5)',
    primary: 'rgba(23, 116, 240, 0.2)',
    accessory: 'rgba(23, 158, 238, 0.08)',
    accessoryAlternative: '#edf8fe',
    gray20: 'rgba(157, 169, 182, 0.2)',
    white20: 'rgba(255, 255, 255, 0.2)',
    white40: 'rgba(255, 255, 255, 0.4)',
    white46: 'rgba(255, 255, 255, 0.46)',
    white50: 'rgba(255, 255, 255, 0.5)',
    errorBold: 'rgb(166, 25, 18)',
    error60: 'rgba(231, 76, 60, 0.6)',
    success10: 'rgba(3, 216, 169, 0.10)',
    success15: 'rgba(3, 216, 169, 0.15)',
    success60: 'rgba(3, 216, 169, 0.6)',
    warning05: 'rgba(240, 140, 0, 0.05)',
    warning10: 'rgba(240, 140, 0, 0.10)',
    warning15: 'rgba(240, 140, 0, 0.15)',
    warning60: 'rgba(240, 140, 0, 0.6)',
    whatsapp: {
      default: '#25d366',
      hover: '#23c660',
    },
    darkGray60: 'rgba(93, 113, 134, 0.6)',
    outlineHover: '#cdf8ee',
    purple10: 'rgba(151, 117, 250, 0.1)',
    indigo: '#07074E',
    transparent: 'rgba(255, 255, 255, 0)',
    floralWhite: '#fffaf2',
  },
};

export { colors };
